import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getPostByPostId = async ({ postId }) => {
	if (!postId) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getPostByPostId')
	}
	try {
		const postDocSnap = await firestore.collection('posts').doc(postId).get()

		if (!postDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { postId }))
		}
		const post = postDocSnap.data()
		if (post.deleted) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { postId, reason: 'deleted' }))
		}

		return { post }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, postId, exception)
	}
}

export default getPostByPostId



// WEBPACK FOOTER //
// ./src/dataservices/getPostByPostId.js